import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { serialise } from '@principle-theorem/shared';
import { JsonEditorOptions, NgJsonEditorModule } from 'ang-jsoneditor';

export interface IViewDataDialogData {
  title: string;
  data: unknown;
}

@Component({
  selector: 'pt-view-data-dialog',
  templateUrl: './view-data-dialog.component.html',
  styleUrls: ['./view-data-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, NgJsonEditorModule],
})
export class ViewDataDialogComponent {
  serializedData: string;
  editorOptions: JsonEditorOptions;
  jsonData: object;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: IViewDataDialogData) {
    this.jsonData = serialise(dialogData.data ?? {});
    this.serializedData = JSON.stringify(this.jsonData);

    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.mode = 'view';
    this.editorOptions.mainMenuBar = false;
    this.editorOptions.navigationBar = true;
    this.editorOptions.statusBar = false;
  }

  async copyToClipboard(): Promise<void> {
    return navigator.clipboard.writeText(this.serializedData);
  }
}
